<div class="user-area-wrapper">
  <opac-user-title [title]="'user.visualizations.title' | translate"></opac-user-title>
  <div class="user-visualization-history">
    <opac-no-results
      *ngIf="!loading && !userService.visualizationHistory.elements.length"
      [label]="'user.visualizations.noVisualizations' | translate">
    </opac-no-results>

    <button
      *ngIf="userService.visualizationHistory.elements.length"
      mat-flat-button
      class="warn transparent delete-all"
      (click)="showDeleteVisualizationHistoryDialog.set(true)">
      {{ 'general.removeAll' | translate }}
    </button>

    <div class="user-visualization-history__list">
      <app-user-visualization-history-item
        *ngFor="let item of userService.visualizationHistory.elements"
        (removed)="onRemoved($event)"
        [item]="item"
        class="list__item"></app-user-visualization-history-item>
    </div>

    <div class="user-visualization-history__more" *ngIf="hasLoadMore">
      <button mat-flat-button class="accent" (click)="loadMore()" [class.waiting]="waiting">
        <ng-container *ngIf="!waiting"> {{ 'results.suggestions.moreResults' | translate }} </ng-container>

        <mat-spinner *ngIf="waiting" [diameter]="30"></mat-spinner>
      </button>
    </div>
  </div>
</div>

<opac-confirmation-dialog
  [acceptLabel]="'general.remove'"
  [open]="showDeleteVisualizationHistoryDialog()"
  [title]="'general.removeAll' | translate"
  (accept)="deleteAll()"
  (cancel)="showDeleteVisualizationHistoryDialog.set(false)">
  <p>{{'messages.visualizationHistory.confirmRemoveAll' | translate}}</p>
</opac-confirmation-dialog>